export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    const { query = '', label = '', ...rest } = props;

    const index = label.indexOf(query);
    const leftPart = label.slice(0, index);
    const rightPart = label.slice(index + query.length, label.length);
    const labels = index >= 0 ? [leftPart, query, rightPart] : [label];

    const _splitLabel = labels.map((l) => ({
      text: l.replace(' ', '\u00A0'),
      bold: query === l
    }));
    return (
      <Component
        {...{
          ...rest,
          _splitLabel,
          ariaLabel: props.ariaLabel || label,
          onClick: () => {
            rest?.onClick?.({
              label,
              icon: rest.icon,
              index: rest.internalIndex
            });
          }
        }}
      />
    );
  };
